<template>
  <vuetify-app-minimal>
    <v-container class='fill-height px-12'>
      <v-row align="center" justify="center">
        <slot name="prepend"></slot>
        <h1 class="text-h2 full-w text-center py-4">{{title}}</h1>
        <h2 class="text-h5 full-w text-center">{{subtitle}}</h2>
        <slot name="append"></slot>
      </v-row>
    </v-container>
  </vuetify-app-minimal>
</template>

<script>
import { defineComponent } from "vue"
import VuetifyAppMinimal from "../VuetifyAppMinimal";

export default defineComponent({
  components: {
    VuetifyAppMinimal
  },
  props: {
    title: {
      type: [String, Number],
    },
    subtitle: {
      type: String,
    }
  }
})
</script>

<style lang="scss" scoped>
.full-w {
  width: 100%;
}
</style>
